import React from 'react';
import PropTypes from 'prop-types';

import Registry from '../../../registry';

const ChatLogItemCensored = ({message, muted}) => {
    const lang = Registry.get('locale');
    return (
        <div className="censored-notification">
            <strong>{message.nick}</strong>
            {muted ? lang.muted_notification : lang.unmuted_notification}
        </div>
    )
}

ChatLogItemCensored.defaultProps = {
    muted: false,
}

ChatLogItemCensored.propTypes = {
    muted: PropTypes.bool,
    message: PropTypes.object.isRequired,
}

export default ChatLogItemCensored;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemCensored/index.js